export interface LanguageDef {
  /** Locale code (e.g. 'en', 'de', 'pt-br') */
  code: string;
  /** Display name in the language itself */
  label: string;
  /** ISO 3166-1 alpha-2 country code for flag display */
  countryCode: string;
}

/**
 * Canonical language list used across all public pages.
 * Single source of truth — imported by PublicHeader and anywhere language selection appears.
 */
export const LANGUAGES: readonly LanguageDef[] = [
  { code: 'en', label: 'English', countryCode: 'GB' },
  { code: 'fr', label: 'Français', countryCode: 'FR' },
  { code: 'it', label: 'Italiano', countryCode: 'IT' },
  { code: 'es', label: 'Español', countryCode: 'ES' },
  { code: 'pt', label: 'Português (PT)', countryCode: 'PT' },
  { code: 'pt-br', label: 'Português (BR)', countryCode: 'BR' },
  { code: 'de', label: 'Deutsch', countryCode: 'DE' },
  { code: 'nl', label: 'Dutch', countryCode: 'NL' },
  { code: 'id', label: 'Bahasa Indonesia', countryCode: 'ID' },
  { code: 'hu', label: 'Magyar', countryCode: 'HU' },
  { code: 'pl', label: 'Polska', countryCode: 'PL' },
  { code: 'ja', label: 'Japanese (日本)', countryCode: 'JP' },
  { code: 'ro', label: 'Română', countryCode: 'RO' },
  { code: 'el', label: 'Greek (Ελληνικά)', countryCode: 'GR' },
  { code: 'tr', label: 'Türkçe', countryCode: 'TR' },
] as const;
